<div class="end-screen">
    <p class="m-0 p-0 text-success">
        Thank you for completing your profile, your details have been updated.
    </p>
    <div class="pt-3">
        <a class="px-5 py-2 btn btn-primary" (click)="comingSoon()">Back</a>
    </div>
</div>